import { useInfiniteQuery } from 'react-query'
import type PaginationDomain from '../../../../types/domain/pagination-domain'

export type GetColumnValuesResponse = {
  id: number
  value: string
}

type UseInfiniteColumnValuesQueryProps = {
  key: string
  searchTerm: string
  onLoadMoreColumnValues: (
    page: number,
    search: string
  ) => Promise<PaginationDomain<GetColumnValuesResponse>>
}

export const useInfiniteColumnValuesQuery = ({
  key,
  searchTerm,
  onLoadMoreColumnValues,
}: UseInfiniteColumnValuesQueryProps) => {
  return useInfiniteQuery(
    [key, searchTerm],
    async ({ pageParam = 1 }) => {
      const response = await onLoadMoreColumnValues(pageParam, searchTerm)
      return response
    },
    {
      staleTime: 1000 * 60 * 5, // 5 minutes
      getNextPageParam ({ meta }) {
        return meta.pageCount === meta.page ? undefined : meta.page + 1
      },
    }
  )
}
